<app-header></app-header>

<div class="checkout-container">
  <div class="checkout-content">
    <!-- Header Section -->
    <div class="header-section">
      <h1 class="page-title">PDF to Word <span class="phone-number">{{ filename }}</span></h1>
      
      <div class="promotional-offer">
        <i class="bi bi-shield-lock-fill"></i>
        <span>Offre promotionnelle: {{ getFormattedAmount() }}€ (*)</span>
      </div>
      
      <div class="security-label">
        PAIEMENT 100% SÉCURISÉ
      </div>
    </div>

    <!-- Payment Information Section -->
    <div class="payment-section">
      <h2 class="section-title">Informations de paiement</h2>

      <!-- Error Message -->
      <div *ngIf="errorMessage" class="error-message">
        <i class="bi bi-exclamation-triangle-fill"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <!-- Stripe Payment Form -->
      <form id="payment-form" class="payment-form" (submit)="onSubmit($event)">
        <div class="form-group">
          <label class="form-label">Numéro de carte</label>
          <div class="input-container">
            <!-- Loading placeholder -->
            <div *ngIf="isLoadingStripe" class="stripe-placeholder">
              <div class="placeholder-content">
                <div class="placeholder-line"></div>
                <div class="placeholder-line short"></div>
              </div>
            </div>
            <!-- Stripe element -->
            <div id="card-number" class="stripe-element" [class.hidden]="isLoadingStripe"></div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Date d'expiration</label>
            <!-- Loading placeholder -->
            <div *ngIf="isLoadingStripe" class="stripe-placeholder">
              <div class="placeholder-content">
                <div class="placeholder-line short"></div>
              </div>
            </div>
            <!-- Stripe element -->
            <div id="card-expiry" class="stripe-element" [class.hidden]="isLoadingStripe"></div>
          </div>
          
          <div class="form-group">
            <label class="form-label">Code de sécurité</label>
            <div class="input-container">
              <!-- Loading placeholder -->
              <div *ngIf="isLoadingStripe" class="stripe-placeholder">
                <div class="placeholder-content">
                  <div class="placeholder-line short"></div>
                </div>
                <div class="cvc-icon">
                  <i class="bi bi-credit-card"></i>
                  <span>123</span>
                </div>
              </div>
              <!-- Stripe element -->
              <div id="card-cvc" class="stripe-element" [class.hidden]="isLoadingStripe"></div>
            </div>
          </div>
        </div>

        <div class="form-group terms-group">
          <label for="terms" class="checkbox-container">
            <input type="checkbox" id="terms" [(ngModel)]="termsAccepted" name="terms" (change)="onTermsChange($event)" required>
            <span class="checkmark"></span>
            <span class="terms-text">J'ai lu et j'accepte les <a href="#" class="terms-link">conditions générales de vente</a>.</span>
          </label>
        </div>

        <button type="submit" class="validate-btn" id="submit-button" [disabled]="!isFormValid() || isProcessing || isLoadingStripe">
          <i class="bi bi-shield-lock-fill"></i>
          <span>{{ isProcessing ? 'Traitement...' : 'Valider' }}</span>
        </button>
      </form>

      <!-- Service Guarantees Section -->
      <div class="guarantees-section my-5">
        <div class="refund-policy">
          Satisfait ou remboursé
        </div>
        
        <ul class="guarantees-list">
          <li>
            <i class="bi bi-check-circle-fill"></i>
            <span>Vous recevez le résultat de la conversion sur votre adresse email instantanément</span>
          </li>
          <li>
            <i class="bi bi-check-circle-fill"></i>
            <span>Conforme au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés</span>
          </li>
          <li>
            <i class="bi bi-check-circle-fill"></i>
            <span>Paiement 100% sécurisé</span>
          </li>
        </ul>
      </div>

    </div>

  </div>
</div>

<app-footer></app-footer>
